module.exports = __webpack_public_path__ + "static/media/piper-head.9992dfd9.svg";